/* Tennis configurator — behaviour for sections/tennis-configurator.liquid.
   Options: 1 = Carat, 2 = Metal, 3 = Length (stored in inches, shown in cm). Same mechanics
   as the earrings configurator: variant JSON, option cards, sticky buy dock, `theme:cart:add`. */
(function () {
  var section = document.querySelector('[data-tennis-configurator]');
  if (!section) return;

  var $ = function (s, r) { return (r || section).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || section).querySelectorAll(s)); };

  var variants = [], cfg = {};
  try { variants = JSON.parse($('[data-variant-json]').textContent); } catch (e) { variants = []; }
  try { cfg = JSON.parse($('[data-config]').textContent); } catch (e) { cfg = {}; }
  var details = cfg.caratDetails || {};

  var form = $('form.tcfg__form');
  var variantInput = $('[data-variant-id]');
  var priceEl = $('[data-price]');
  var dockPrice = $('[data-dock-price]');
  var dockSub = $('[data-dock-sub]');
  var addButton = $('[data-add-button]');
  var addText = $('[data-add-text]');
  var availability = $('[data-availability]');
  var summaryCarat = $('[data-summary-carat]');
  var summaryMetal = $('[data-summary-metal]');
  var summaryLength = $('[data-summary-length]');
  var summarySetting = $('[data-summary-setting]');
  var summaryThumb = $('[data-summary-thumb]');

  // ---- money: whole units, no cents, narrow symbol (€7,440 / kr 78 000) ----
  function money(cents, signed) {
    var n = Math.round(cents / 100), s;
    try {
      s = new Intl.NumberFormat(cfg.locale || document.documentElement.lang || 'en', {
        style: 'currency', currency: cfg.currency || 'EUR', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0, minimumFractionDigits: 0
      }).format(Math.abs(n));
    } catch (e) { s = Math.abs(n) + ' ' + (cfg.currency || ''); }
    if (!signed) return s;
    return n === 0 ? s : (n > 0 ? '+ ' : '– ') + s;
  }

  // ---- selection state, read from the cards' aria-checked ----
  function selected(pos) {
    var on = $('[data-option-card][data-option-position="' + pos + '"][aria-checked="true"]');
    return on ? on.getAttribute('data-option-value') : null;
  }
  function setChecked(pos, value) {
    $$('[data-option-card][data-option-position="' + pos + '"]').forEach(function (c) {
      c.setAttribute('aria-checked', c.getAttribute('data-option-value') === value ? 'true' : 'false');
    });
  }
  function find(o1, o2, o3) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((o1 == null || v.option1 === o1) && (o2 == null || v.option2 === o2) && (o3 == null || v.option3 === o3)) return v;
    }
    return null;
  }
  function exists(o1, o2, o3) { return !!find(o1, o2, o3); }
  function colourOf(metal) { return /white/i.test(metal || '') ? 'White gold' : (/rose/i.test(metal || '') ? 'Rose gold' : 'Yellow gold'); }

  // ---- carat helpers: exact total for the chosen length (variant metafield, SKU fallback) ----
  function caratFromSku(sku) {
    var m = String(sku || '').match(/-(\d+)CT-/); if (!m) return null;
    var n = parseInt(m[1], 10); if (n <= 12) return n;
    var d = [10, 100, 1000, 10000];
    for (var i = 0; i < d.length; i++) { if (n / d[i] <= 12) return Math.round(n / d[i] * 1000) / 1000; }
    return null;
  }
  function caratOf(v) { return v && v.carat != null ? Number(v.carat) : caratFromSku(v && v.sku); }
  function fmtCt(n, dp) {
    if (n == null || isNaN(n)) return '';
    var r = Math.round(n * 100) / 100;
    if (dp === 1) r = Math.round(n * 10) / 10;
    return (Number.isInteger(r) ? r : String(r).replace(/\.?0+$/, '')) + ' ct';
  }
  function caratNum(label) { var m = String(label).match(/[\d.]+/); return m ? parseFloat(m[0]) : NaN; }
  function feelsLike(c) { if (c < 4) return 'Fine, everyday'; if (c < 6) return 'Classic'; if (c < 8) return 'Statement'; return 'Bold'; }

  // ---- length: option values are inches, the page speaks centimetres ----
  function cmOf(label) {
    var n = parseFloat(label); if (isNaN(n)) return String(label);
    return String(Math.round(n * 2.54 * 10 + 1e-6) / 10);           // 7.5 in → 19.05 → 19.1, not 19.0
  }
  function fmtLen(label) { return cmOf(label) + ' cm'; }

  // ---- gallery: only the media of the selected carat + colour, lifestyle shots always ----
  var slides = $$('[data-slide]'), thumbs = $$('[data-thumb]'), dotsWrap = $('[data-dots]'), badge360 = $('[data-video-jump]');
  var visible = [], current = 0;
  function computeVisible(carat, colour) {
    var tagged = slides.filter(function (s) { return s.getAttribute('data-carat'); });
    var match = function (s, c, col) { return (!c || s.getAttribute('data-carat') === c) && (!col || s.getAttribute('data-colour') === col); };
    var set = tagged.filter(function (s) { return match(s, carat, colour); });
    if (!set.length) set = tagged.filter(function (s) { return match(s, null, colour); });
    if (!set.length) set = tagged;
    var untagged = slides.filter(function (s) { return !s.getAttribute('data-carat'); });
    return untagged.concat(set);                                      // lifestyle first, then the renders
  }
  function pauseVideos() { $$('video', section).forEach(function (v) { try { v.pause(); } catch (e) {} }); }
  function showSlide(i) {
    if (!visible.length) return;
    i = Math.max(0, Math.min(visible.length - 1, i)); current = i;
    pauseVideos();
    slides.forEach(function (s) { var on = visible[i] === s; s.hidden = visible.indexOf(s) === -1; s.classList.toggle('is-active', on); });
    var vid = visible[i].querySelector('video'); if (vid) { try { vid.play(); } catch (e) {} }
    $$('[data-dot]', dotsWrap).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    thumbs.forEach(function (t) { var s = slides[parseInt(t.getAttribute('data-index'), 10)]; t.hidden = visible.indexOf(s) === -1; t.classList.toggle('is-active', s === visible[i]); });
    var active = thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0];
    if (active && active.scrollIntoView) { try { active.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
  }
  function rebuildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    if (visible.length > 1) visible.forEach(function (s, k) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tcfg__dot'; b.setAttribute('data-dot', ''); b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Photo ' + (k + 1));
      b.addEventListener('click', function () { showSlide(k); }); dotsWrap.appendChild(b);
    });
    if (badge360) {
      var vi = visible.map(function (s) { return s.getAttribute('data-type'); }).indexOf('video');
      badge360.hidden = vi === -1; badge360.onclick = function () { showSlide(vi); };
    }
  }
  function applyGallery(carat, colour) {
    var keep = visible[current];
    visible = computeVisible(carat, colour); rebuildDots();
    var front = visible.map(function (s) { return s.getAttribute('data-view'); }).indexOf('front');
    var idx = keep && visible.indexOf(keep) > -1 && keep.getAttribute('data-carat') === '' ? visible.indexOf(keep) : (front > -1 ? front : 0);
    showSlide(idx);
    if (summaryThumb && visible[idx]) { var img = visible[idx].querySelector('img'); if (img && img.currentSrc) summaryThumb.src = img.currentSrc; }
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { var s = slides[parseInt(t.getAttribute('data-index'), 10)]; var i = visible.indexOf(s); if (i > -1) showSlide(i); }); });
  var stage = $('[data-stage]');
  if (stage) {
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 40) return; showSlide(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  // ---- render everything from the current selection ----
  function updateCaratPrices() {
    var metal = selected(2), length = selected(3);
    $$('[data-carat-price]').forEach(function (el) {
      var carat = el.getAttribute('data-carat-price');
      var v = find(carat, metal, length) || find(carat, metal, null) || find(carat, null, null);
      var card = el.closest('[data-option-card]');
      if (v) { el.textContent = money(v.price); card.classList.remove('is-unavailable'); card.removeAttribute('aria-disabled'); }
      else { el.textContent = '—'; card.classList.add('is-unavailable'); card.setAttribute('aria-disabled', 'true'); }
    });
  }
  function updateMetalDeltas() {
    var carat = selected(1), metal = selected(2), length = selected(3);
    var base = find(carat, metal, length);
    $$('[data-metal-delta]').forEach(function (el) {
      var m = el.getAttribute('data-metal-delta');
      var v = find(carat, m, length) || find(carat, m, null);
      var card = el.closest('[data-option-card]');
      if (!v) { el.textContent = '—'; card.classList.add('is-unavailable'); return; }
      card.classList.remove('is-unavailable');
      el.textContent = (m === metal) ? 'Selected' : (base ? money(v.price - base.price, true) : money(v.price));
    });
  }
  // the size cards show the total carat weight AT that length for the chosen carat + metal
  function updateSizeCarats() {
    var carat = selected(1), metal = selected(2);
    $$('[data-size-ct]').forEach(function (el) {
      var len = el.getAttribute('data-size-ct');
      var v = find(carat, metal, len) || find(carat, null, len);
      var card = el.closest('[data-option-card]');
      var total = caratOf(v);
      el.textContent = total ? fmtCt(total, 1) : (v ? '' : '—');
      card.classList.toggle('is-unavailable', !v);
    });
  }
  function updateSiblings() {
    var metal = selected(2), length = selected(3);
    $$('[data-cut-link]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        if (metal) u.searchParams.set('metal', metal); if (length) u.searchParams.set('length', length);
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    });
  }
  function update() {
    var o1 = selected(1), o2 = selected(2), o3 = selected(3);
    var v = find(o1, o2, o3);
    updateCaratPrices(); updateMetalDeltas(); updateSizeCarats(); updateSiblings();
    var d = details[o1] || {};
    var total = caratOf(v);
    if (summaryCarat) summaryCarat.textContent = total ? fmtCt(total) : (o1 || '');
    if (summaryMetal) summaryMetal.textContent = o2 || '';
    if (summaryLength) summaryLength.textContent = o3 ? fmtLen(o3) : '';
    if (summarySetting) summarySetting.textContent = d.prongs ? d.prongs : '—';
    if (dockSub) dockSub.textContent = [o2, o3 ? fmtLen(o3) : ''].filter(Boolean).join(' · ');
    $$('tr', $('[data-wrist-table]')).forEach(function (tr) { tr.classList.toggle('is-active', tr.getAttribute('data-carat') === o1); });

    if (!v) {
      variantInput.value = '';
      addButton.disabled = true; addText.textContent = 'Unavailable';
      availability.textContent = 'This combination is not available — try another metal or length.';
      return;
    }
    variantInput.value = v.id;
    var p = money(v.price);
    if (priceEl) priceEl.textContent = p;
    if (dockPrice) dockPrice.textContent = p;
    addButton.disabled = !v.available;
    addText.textContent = v.available ? (cfg.addLabel || 'Add to cart') : 'Unavailable';
    availability.textContent = v.available ? '' : 'Currently unavailable in this combination.';
    applyGallery(o1, colourOf(o2));
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('metal'); u.searchParams.delete('length'); u.searchParams.delete('carat'); history.replaceState(history.state, '', u.toString()); } catch (e) {}
  }

  // ---- option clicks; auto-repair the other options if the combo does not exist ----
  section.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-option-card]');
    if (!card || !section.contains(card)) return;
    var pos = card.getAttribute('data-option-position'), val = card.getAttribute('data-option-value');
    setChecked(pos, val);
    var o1 = selected(1), o2 = selected(2), o3 = selected(3);
    if (!exists(o1, o2, o3)) {
      var fix = (pos === '1' && (find(o1, o2, null) || find(o1, null, o3) || find(o1, null, null)))
             || (pos === '2' && (find(o1, o2, null) || find(null, o2, o3) || find(null, o2, null)))
             || (pos === '3' && (find(o1, null, o3) || find(null, o2, o3) || find(null, null, o3)))
             || find(null, null, null);
      if (fix) { setChecked(1, fix.option1); setChecked(2, fix.option2); setChecked(3, fix.option3); }
    }
    update();
  });

  // ---- arriving from a sibling cut (?metal=…&length=…) or a campaign (?carat=…) ----
  try {
    var params = new URL(location.href).searchParams;
    if (!params.get('variant')) {
      var want = [params.get('carat'), params.get('metal'), params.get('length')];
      if (want.some(Boolean)) {
        var cur = [selected(1), selected(2), selected(3)];
        var target = want.map(function (w, i) { return w || cur[i]; });
        var pv = find(target[0], target[1], target[2]) || find(null, target[1], target[2]) || find(target[0], target[1], null) || find(null, target[1], null) || find(null, null, target[2]);
        if (pv) { setChecked(1, pv.option1); setChecked(2, pv.option2); setChecked(3, pv.option3); }
      }
    }
  } catch (e) {}

  // ---- add to cart: Broadcast's <product-form> intercepts submit and dispatches
  //      `theme:cart:add` itself; only do it ourselves when the element is missing. ----
  if (form && !customElements.get('product-form')) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addButton.disabled) return;
      document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: addButton }, bubbles: false }));
      if (window.a11y) window.a11y.lastElement = addButton;
    });
  }

  // ---- sticky buy dock on mobile ----
  var buySlot = $('[data-buy-slot]'), buyDock = $('[data-buy-dock]');
  var mq = window.matchMedia('(max-width: 749px)'), frame = 0;
  function updateDock() {
    frame = 0;
    if (!buySlot || !buyDock) return;
    if (!mq.matches) { buyDock.classList.remove('is-fixed'); buySlot.style.removeProperty('height'); liftLaunchers(0); return; }
    buySlot.style.height = buyDock.offsetHeight + 'px';
    var fixed = buySlot.getBoundingClientRect().bottom > window.innerHeight;
    buyDock.classList.toggle('is-fixed', fixed);
    liftLaunchers(fixed ? buyDock.offsetHeight : 0);
  }
  // Third-party launchers float over the sticky dock on mobile: Shopify Inbox's "Support"
  // button (bottom-right, host <shopify-chat> is a full-viewport fixed grid whose launcher
  // sits at its bottom edge) and Klaviyo's teaser (bottom-left, fixed). While the dock is
  // fixed, lift both above it; the open chat panel is positioned on its own and unaffected.
  function liftLaunchers(px) {
    var targets = [document.querySelector('shopify-chat')].concat(
      $$('[class*="kl-teaser"]', document).filter(function (e) { return getComputedStyle(e).position === 'fixed'; }));
    targets.forEach(function (el) {
      if (!el) return;
      if (px) el.style.setProperty('bottom', (px + 8) + 'px', 'important'); else el.style.removeProperty('bottom');
    });
  }
  function scheduleDock() { if (!frame) frame = requestAnimationFrame(updateDock); }
  window.addEventListener('scroll', scheduleDock, { passive: true });
  window.addEventListener('resize', scheduleDock);
  if (mq.addEventListener) mq.addEventListener('change', scheduleDock);
  if ('ResizeObserver' in window && buyDock) new ResizeObserver(scheduleDock).observe(buyDock);
  window.addEventListener('load', scheduleDock);
  setTimeout(scheduleDock, 1500); setTimeout(scheduleDock, 4000);

  // ---- modals: carat size guide (wrist photo + table) and how to measure ----
  var wristTable = $('[data-wrist-table]'), measureTable = $('[data-measure-table]');
  function buildWristTable() {
    if (!wristTable) return;
    wristTable.innerHTML = $$('[data-option-card][data-option-position="1"]').map(function (c) {
      var label = c.getAttribute('data-option-value'), d = details[label] || {}, r = d.range;
      var range = r && r[0] !== r[1] ? fmtCt(r[0]).replace(' ct', '') + '–' + fmtCt(r[1]) : (r ? fmtCt(r[0]) : '—');
      return '<tr data-carat="' + label.replace(/"/g, '&quot;') + '"><td>' + label + '</td><td>' + range + '</td><td>' + feelsLike(caratNum(label)) + '</td></tr>';
    }).join('');
  }
  function nearestLength(inches) {
    var opts = $$('[data-option-card][data-option-position="3"]').map(function (c) { return parseFloat(c.getAttribute('data-option-value')); }).filter(function (n) { return !isNaN(n); });
    if (!opts.length) return null;
    var best = opts[0]; opts.forEach(function (o) { if (Math.abs(o - inches) < Math.abs(best - inches)) best = o; });
    return best;
  }
  function buildMeasureTable() {
    if (!measureTable) return;
    var rows = [];
    for (var w = 5.5; w <= 8; w += 0.5) {
      var snug = nearestLength(w + 0.5), relaxed = nearestLength(w + 1);
      rows.push('<tr><td>' + fmtLen(w) + '</td><td>' + (snug ? fmtLen(snug) : '—') + '</td><td>' + (relaxed ? fmtLen(relaxed) : '—') + '</td></tr>');
    }
    measureTable.innerHTML = rows.join('');
  }
  function modalCtl(root, openSel, closeSel) {
    if (!root) return;
    var lastFocus = null;
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', root).filter(function (el) { return !el.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      lastFocus = document.activeElement;
      root.hidden = false; document.documentElement.classList.add('tcfg-modal-open');
      var c = $('.tcfg__modal-close', root); if (c) c.focus();
      document.addEventListener('keydown', onKey, true);
    }
    function close() {
      root.hidden = true; document.documentElement.classList.remove('tcfg-modal-open');
      document.removeEventListener('keydown', onKey, true);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }
    $$(openSel).forEach(function (b) { b.addEventListener('click', open); });
    $$(closeSel, root).forEach(function (b) { b.addEventListener('click', close); });
  }
  modalCtl($('[data-size-guide]'), '[data-size-guide-open]', '[data-size-guide-close]');
  modalCtl($('[data-measure]'), '[data-measure-open]', '[data-measure-close]');
  buildWristTable(); buildMeasureTable();

  // ---- boot ----
  update();
  updateDock();
})();
